(function () {
  'use strict';

  angular
    .module('module.modal-controllers', [])

    /* @ngInject */
    .controller('modalCtrl', ["data", "device", "options", "$scope", function (data, device, options, $scope) {
      var ctrl = this;
      ctrl.data = data;
      ctrl.device = device;
      ctrl.options = options;
      ctrl.showLoader = true;
      $scope.device = device;

      ctrl.onLoad = function () {
        ctrl.showLoader = false;
      };
    }])

    /* @ngInject */
    .controller('modalAddToCartCtrl', ["data", "device", "options", "$scope", function (data, device, options, $scope) {
      var ctrl = this;
      ctrl.data = data;
      ctrl.device = device;
      ctrl.options = options;
      $scope.device = device;

      if (ctrl.data.length === 1) {
        ctrl.suggestionsUrl = 'GetProductSuggestions/Modal/ModalAddToCartSuggestions/' + ctrl.data[0].idProduct + '?' + (new Date().getTime());
      }

    }])

    /* @ngInject */
    .controller('modalSendByEMailCtrl', ["data", "device", "options", "HttpService", "AppService", "ModalService", "toastr", function (data, device, options, HttpService, AppService, ModalService, toastr) {
      var ctrl = this;

      ctrl.data = data;
      ctrl.data.Message = '';
      ctrl.data.Recipients = [{}];
      ctrl.modalTitle = options.modalTitle;

      ctrl.addRecipient = function () {
        ctrl.data.Recipients.push({});
      };
      ctrl.removeRecipient = function (index) {
        ctrl.data.Recipients.splice(index, 1);
      };

      AppService.getParams()
        .then(function (params) {
          if (params.IsLogged) {
            ctrl.data.Email = params.Visitor.Email;
            ctrl.data.FirstName = params.Visitor.FirstName;
            ctrl.data.LastName = params.Visitor.LastName;
          }
        })
        .catch(function (error) {
          console.error(error);
        });

      ctrl.submit = function () {
        ctrl.loading = true;

        HttpService.post({
          url: '/SendByEmail',
          data: ctrl.data
        })
        .then(function (response) {
          AppService.getTranslate()
            .then(function (translate) {
              if (response.status === 'OK') {
                ModalService.close();
                toastr.success('', options.resultMessage, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
              } else {
                toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
              }
              ctrl.loading = false;
            })
            .catch(function (error) {
              console.error(error);
            });
        })
        .catch(function (error) {
          console.error(error);
        });
      };

    }])

    /* @ngInject */
    .controller('modalAvailabilityAlertCtrl', ["data", "device", "options", "ModalService", "AppService", "HttpService", "toastr", function (data, device, options, ModalService, AppService, HttpService, toastr) {
      var ctrl = this;
      ctrl.data = data;
      ctrl.data.Email = '';

      var messageTitle,
        messageText;

      ctrl.successMessage = function (title, text) {
        messageTitle = title;
        messageText = text;
      };

      ctrl.submit = function () {
        ctrl.loading = true;
        HttpService.post({
          url: '/Product/AvailabilityAlert',
          data: ctrl.data
        })
          .then(function (response) {
            ctrl.loading = false;
            if (response.status === 'OK') {
              ModalService.close();
              toastr.success(messageText, messageTitle, {
                allowHtml: true,
                extraData: {
                  template: 'toast_message.tpl'
                }
              });
            } else {
              AppService.getTranslate()
                .then(function (translate) {
                  toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                    allowHtml: true,
                    extraData: {
                      template: 'toast_message.tpl'
                    }
                  });
                })
                .catch(function (error) {
                  console.error(error);
                });
            }
          })
          .catch(function (error) {
            console.error(error);
          });
      };
    }])

    /* @ngInject */
    .controller('modalQuickViewCtrl', ["data", "device", "options", "$scope", function (data, device, options, $scope) {
      var ctrl = this;
      ctrl.data = data;
      ctrl.device = device;
      ctrl.options = options;
      ctrl.showLoader = true;
      $scope.device = device;

      ctrl.onLoad = function () {
        ctrl.showLoader = false;
        setTimeout(function () {
          $('.modal-quick-view .modal-body').removeAttr('style');
        });
      };
    }])

    /* @ngInject */
    .controller('uploadCropModalCtrl', ["data", "device", "options", "$scope", "ModalService", "Environment", "$uibModalInstance", function (data, device, options, $scope, ModalService, Environment, $uibModalInstance) {
      var ctrl = this;
      ctrl.data = data;
      ctrl.device = device;
      ctrl.options = options;
      ctrl.showLoader = true;
      $scope.device = device;

      var cropper;

      $uibModalInstance.rendered.then(function () {
        init();
      });

      ctrl.plus = function () {
        cropper.zoom(0.1);
      };
      ctrl.minus = function () {
        cropper.zoom(-0.1);
      };
      ctrl.rotate = function () {
        cropper.rotate(90);
      };

      ctrl.save = function () {
        var dropzone = ctrl.data.ctrlFrom.dzMethods.getDropzone();
        dropzone.options.url = '/Upload';
        var blob = cropper.getCroppedCanvas(
          {
            width: 240,
            height: 240,
            fillColor: '#fff',
            imageSmoothingEnabled: true,
            imageSmoothingQuality: 'high'
          })
          .toDataURL('image/jpeg');
        var croppedFile = dataURItoBlob(blob);
        croppedFile.name = ctrl.data.name;

        ctrl.data.ctrlFrom.tmpFileName = ctrl.data.name;
        dropzone.removeAllFiles();
        dropzone.addFile(croppedFile);

        ctrl.data.ctrlFrom.deleteTmpFile(ctrl.data.serverName);
        ModalService.close();
      };

      function init() {
        if (typeof Cropper === 'undefined') {
          $.ajax({
            url: Environment === 'dev' ? '/js/cropper.js' : '/js/cropper.min.js',
            dataType: 'script',
            cache: true,
            success: function () {
              ctrl.showLoader = false;
              initCropper();
            }
          });
        } else {
          initCropper();
        }
      }

      function initCropper() {
        cropper = new Cropper(document.getElementById('img_' + ctrl.data.tmpId), {
          aspectRatio: 1,
          movable: true,
          cropBoxResizable: true,
          rotatable: true,
          ready: function () {
            // eslint-disable-next-line
            $(this.cropper.cropper).addClass('cropper-circle');
          }
        });
      }

      function dataURItoBlob(dataURI) {
        var byteString = atob(dataURI.split(',')[1]);
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: 'image/jpeg' });
      }
    }]);
})();
